function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 193,
  y: 1,
  width: 80,
  height: 80,
  fill: "white",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M192 0V82",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 42,
  width: 190,
  height: 39,
  fill: "white",
  stroke: "white",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M76.18 65.3H77.272V58.784H76.18V65.3ZM76.732 57.44C77.164 57.44 77.464 57.152 77.464 56.708C77.464 56.288 77.164 56 76.732 56C76.3 56 76 56.288 76 56.708C76 57.152 76.3 57.44 76.732 57.44Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M79.4847 65.3H80.5767V60.572C81.1767 59.9 81.7287 59.576 82.2207 59.576C83.0487 59.576 83.4327 60.092 83.4327 61.316V65.3H84.5247V60.572C85.1367 59.9 85.6647 59.576 86.1687 59.576C86.9967 59.576 87.3807 60.092 87.3807 61.316V65.3H88.4727V61.172C88.4727 59.504 87.8367 58.616 86.4927 58.616C85.7007 58.616 85.0167 59.132 84.3447 59.864C84.0807 59.096 83.5407 58.616 82.5447 58.616C81.7647 58.616 81.0807 59.108 80.5167 59.732H80.4807L80.3847 58.784H79.4847V65.3Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M92.0941 65.456C92.8981 65.456 93.6301 65.036 94.2541 64.52H94.2901L94.3861 65.3H95.2861V61.292C95.2861 59.684 94.6141 58.616 93.0301 58.616C91.9861 58.616 91.0621 59.084 90.4621 59.468L90.8941 60.224C91.4101 59.876 92.0941 59.528 92.8501 59.528C93.9181 59.528 94.1941 60.332 94.1941 61.172C91.4221 61.484 90.1861 62.192 90.1861 63.608C90.1861 64.784 91.0021 65.456 92.0941 65.456ZM92.4061 64.58C91.7581 64.58 91.2541 64.28 91.2541 63.536C91.2541 62.696 91.9981 62.156 94.1941 61.892V63.716C93.5581 64.28 93.0421 64.58 92.4061 64.58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5635 68.3C101.58 68.3 102.864 67.256 102.864 66.044C102.864 64.976 102.096 64.496 100.583 64.496H99.3115C98.4355 64.496 98.1715 64.208 98.1715 63.788C98.1715 63.428 98.3515 63.212 98.5915 63.008C98.8795 63.152 99.2395 63.236 99.5635 63.236C100.883 63.236 101.94 62.36 101.94 60.968C101.94 60.404 101.724 59.924 101.412 59.624H102.743V58.784H100.476C100.247 58.7 99.9235 58.616 99.5635 58.616C98.2435 58.616 97.1155 59.516 97.1155 60.944C97.1155 61.724 97.5355 62.348 97.9675 62.696V62.744C97.6315 62.984 97.2355 63.416 97.2355 63.956C97.2355 64.472 97.4875 64.82 97.8355 65.024V65.072C97.2235 65.468 96.8755 65.996 96.8755 66.548C96.8755 67.676 97.9675 68.3 99.5635 68.3ZM99.5635 62.492C98.8075 62.492 98.1715 61.892 98.1715 60.944C98.1715 59.984 98.7955 59.42 99.5635 59.42C100.331 59.42 100.956 59.996 100.956 60.944C100.956 61.892 100.307 62.492 99.5635 62.492ZM99.7195 67.556C98.5435 67.556 97.8355 67.1 97.8355 66.404C97.8355 66.02 98.0275 65.636 98.4955 65.3C98.7835 65.372 99.0955 65.408 99.3355 65.408H100.464C101.328 65.408 101.795 65.612 101.795 66.212C101.795 66.896 100.967 67.556 99.7195 67.556Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M106.581 65.456C107.469 65.456 108.165 65.156 108.741 64.784L108.345 64.064C107.865 64.388 107.349 64.58 106.713 64.58C105.477 64.58 104.625 63.692 104.553 62.3H108.945C108.969 62.144 108.993 61.916 108.993 61.676C108.993 59.816 108.057 58.616 106.401 58.616C104.889 58.616 103.461 59.936 103.461 62.048C103.461 64.196 104.853 65.456 106.581 65.456ZM104.541 61.508C104.673 60.236 105.489 59.492 106.413 59.492C107.433 59.492 108.033 60.2 108.033 61.508H104.541Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M110.022 65.3H115.554V64.352H113.07C112.614 64.352 112.086 64.4 111.63 64.436C113.658 62.3 115.122 60.704 115.122 59.096C115.122 57.584 114.138 56.588 112.566 56.588C111.45 56.588 110.694 57.104 109.974 57.884L110.61 58.496C111.09 57.932 111.714 57.476 112.434 57.476C113.526 57.476 114.054 58.172 114.054 59.144C114.054 60.548 112.602 62.084 110.022 64.652V65.3Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 190,
  height: 39,
  fill: "white",
  stroke: "white",
  strokeWidth: 2
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M76.18 24.3H77.272V17.784H76.18V24.3ZM76.732 16.44C77.164 16.44 77.464 16.152 77.464 15.708C77.464 15.288 77.164 15 76.732 15C76.3 15 76 15.288 76 15.708C76 16.152 76.3 16.44 76.732 16.44Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M79.4847 24.3H80.5767V19.572C81.1767 18.9 81.7287 18.576 82.2207 18.576C83.0487 18.576 83.4327 19.092 83.4327 20.316V24.3H84.5247V19.572C85.1367 18.9 85.6647 18.576 86.1687 18.576C86.9967 18.576 87.3807 19.092 87.3807 20.316V24.3H88.4727V20.172C88.4727 18.504 87.8367 17.616 86.4927 17.616C85.7007 17.616 85.0167 18.132 84.3447 18.864C84.0807 18.096 83.5407 17.616 82.5447 17.616C81.7647 17.616 81.0807 18.108 80.5167 18.732H80.4807L80.3847 17.784H79.4847V24.3Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M92.0941 24.456C92.8981 24.456 93.6301 24.036 94.2541 23.52H94.2901L94.3861 24.3H95.2861V20.292C95.2861 18.684 94.6141 17.616 93.0301 17.616C91.9861 17.616 91.0621 18.084 90.4621 18.468L90.8941 19.224C91.4101 18.876 92.0941 18.528 92.8501 18.528C93.9181 18.528 94.1941 19.332 94.1941 20.172C91.4221 20.484 90.1861 21.192 90.1861 22.608C90.1861 23.784 91.0021 24.456 92.0941 24.456ZM92.4061 23.58C91.7581 23.58 91.2541 23.28 91.2541 22.536C91.2541 21.696 91.9981 21.156 94.1941 20.892V22.716C93.5581 23.28 93.0421 23.58 92.4061 23.58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5635 27.3C101.58 27.3 102.864 26.256 102.864 25.044C102.864 23.976 102.096 23.496 100.583 23.496H99.3115C98.4355 23.496 98.1715 23.208 98.1715 22.788C98.1715 22.428 98.3515 22.212 98.5915 22.008C98.8795 22.152 99.2395 22.236 99.5635 22.236C100.883 22.236 101.94 21.36 101.94 19.968C101.94 19.404 101.724 18.924 101.412 18.624H102.743V17.784H100.476C100.247 17.7 99.9235 17.616 99.5635 17.616C98.2435 17.616 97.1155 18.516 97.1155 19.944C97.1155 20.724 97.5355 21.348 97.9675 21.696V21.744C97.6315 21.984 97.2355 22.416 97.2355 22.956C97.2355 23.472 97.4875 23.82 97.8355 24.024V24.072C97.2235 24.468 96.8755 24.996 96.8755 25.548C96.8755 26.676 97.9675 27.3 99.5635 27.3ZM99.5635 21.492C98.8075 21.492 98.1715 20.892 98.1715 19.944C98.1715 18.984 98.7955 18.42 99.5635 18.42C100.331 18.42 100.956 18.996 100.956 19.944C100.956 20.892 100.307 21.492 99.5635 21.492ZM99.7195 26.556C98.5435 26.556 97.8355 26.1 97.8355 25.404C97.8355 25.02 98.0275 24.636 98.4955 24.3C98.7835 24.372 99.0955 24.408 99.3355 24.408H100.464C101.328 24.408 101.795 24.612 101.795 25.212C101.795 25.896 100.967 26.556 99.7195 26.556Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M106.581 24.456C107.469 24.456 108.165 24.156 108.741 23.784L108.345 23.064C107.865 23.388 107.349 23.58 106.713 23.58C105.477 23.58 104.625 22.692 104.553 21.3H108.945C108.969 21.144 108.993 20.916 108.993 20.676C108.993 18.816 108.057 17.616 106.401 17.616C104.889 17.616 103.461 18.936 103.461 21.048C103.461 23.196 104.853 24.456 106.581 24.456ZM104.541 20.508C104.673 19.236 105.489 18.492 106.413 18.492C107.433 18.492 108.033 19.2 108.033 20.508H104.541Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M110.55 24.3H115.374V23.388H113.61V15.744H112.77C112.29 16.032 111.726 16.236 110.946 16.368V17.076H112.506V23.388H110.55V24.3Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M0 41H192",
  stroke: "#222222",
  strokeOpacity: 0.2,
  strokeDasharray: "3 3"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M213.18 44.3H214.272V37.784H213.18V44.3ZM213.732 36.44C214.164 36.44 214.464 36.152 214.464 35.708C214.464 35.288 214.164 35 213.732 35C213.3 35 213 35.288 213 35.708C213 36.152 213.3 36.44 213.732 36.44Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M216.485 44.3H217.577V39.572C218.177 38.9 218.729 38.576 219.221 38.576C220.049 38.576 220.433 39.092 220.433 40.316V44.3H221.525V39.572C222.137 38.9 222.665 38.576 223.169 38.576C223.997 38.576 224.381 39.092 224.381 40.316V44.3H225.473V40.172C225.473 38.504 224.837 37.616 223.493 37.616C222.701 37.616 222.017 38.132 221.345 38.864C221.081 38.096 220.541 37.616 219.545 37.616C218.765 37.616 218.081 38.108 217.517 38.732H217.481L217.385 37.784H216.485V44.3Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M229.094 44.456C229.898 44.456 230.63 44.036 231.254 43.52H231.29L231.386 44.3H232.286V40.292C232.286 38.684 231.614 37.616 230.03 37.616C228.986 37.616 228.062 38.084 227.462 38.468L227.894 39.224C228.41 38.876 229.094 38.528 229.85 38.528C230.918 38.528 231.194 39.332 231.194 40.172C228.422 40.484 227.186 41.192 227.186 42.608C227.186 43.784 228.002 44.456 229.094 44.456ZM229.406 43.58C228.758 43.58 228.254 43.28 228.254 42.536C228.254 41.696 228.998 41.156 231.194 40.892V42.716C230.558 43.28 230.042 43.58 229.406 43.58Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M236.563 47.3C238.58 47.3 239.864 46.256 239.864 45.044C239.864 43.976 239.096 43.496 237.583 43.496H236.312C235.436 43.496 235.172 43.208 235.172 42.788C235.172 42.428 235.351 42.212 235.591 42.008C235.879 42.152 236.24 42.236 236.563 42.236C237.883 42.236 238.94 41.36 238.94 39.968C238.94 39.404 238.724 38.924 238.412 38.624H239.743V37.784H237.476C237.247 37.7 236.924 37.616 236.563 37.616C235.243 37.616 234.115 38.516 234.115 39.944C234.115 40.724 234.536 41.348 234.968 41.696V41.744C234.632 41.984 234.236 42.416 234.236 42.956C234.236 43.472 234.488 43.82 234.836 44.024V44.072C234.224 44.468 233.875 44.996 233.875 45.548C233.875 46.676 234.967 47.3 236.563 47.3ZM236.563 41.492C235.807 41.492 235.172 40.892 235.172 39.944C235.172 38.984 235.795 38.42 236.563 38.42C237.331 38.42 237.956 38.996 237.956 39.944C237.956 40.892 237.307 41.492 236.563 41.492ZM236.719 46.556C235.543 46.556 234.836 46.1 234.836 45.404C234.836 45.02 235.028 44.636 235.496 44.3C235.784 44.372 236.096 44.408 236.336 44.408H237.464C238.328 44.408 238.795 44.612 238.795 45.212C238.795 45.896 237.967 46.556 236.719 46.556Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M243.581 44.456C244.469 44.456 245.165 44.156 245.741 43.784L245.345 43.064C244.865 43.388 244.349 43.58 243.713 43.58C242.477 43.58 241.625 42.692 241.553 41.3H245.945C245.969 41.144 245.993 40.916 245.993 40.676C245.993 38.816 245.057 37.616 243.401 37.616C241.889 37.616 240.461 38.936 240.461 41.048C240.461 43.196 241.853 44.456 243.581 44.456ZM241.541 40.508C241.673 39.236 242.489 38.492 243.413 38.492C244.433 38.492 245.033 39.2 245.033 40.508H241.541Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M249.662 44.456C251.222 44.456 252.482 43.544 252.482 42.02C252.482 40.844 251.654 40.088 250.622 39.836V39.788C251.546 39.452 252.182 38.792 252.182 37.76C252.182 36.368 251.102 35.588 249.626 35.588C248.606 35.588 247.826 36.032 247.166 36.656L247.754 37.34C248.246 36.836 248.87 36.476 249.578 36.476C250.49 36.476 251.066 37.004 251.066 37.832C251.066 38.732 250.442 39.44 248.63 39.44V40.28C250.658 40.28 251.366 40.952 251.366 41.972C251.366 42.932 250.622 43.544 249.578 43.544C248.582 43.544 247.91 43.076 247.394 42.536L246.842 43.256C247.418 43.88 248.282 44.456 249.662 44.456Z",
  fill: "#222222",
  fillOpacity: 0.6
});

var SvgImageTemplate8 = function SvgImageTemplate8(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 82,
    viewBox: "0 0 274 82",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageTemplate8, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image_template8.6b128809.svg";
export { ForwardRef as ReactComponent };